import axios from "axios"

export const state = {
    listagemSelected: "pendentes",
    loadingProdutosAtivos: false,
    produtosAtivos: { content: [] },
    produtoDetail: {},
    nextProdutoDetail: {},
    produtoAtual: 1,
    currentPage: 1,
    filtroPendente: false,
    imagensResponse: [],
    novaBusca: {
        idSecao: null,
        idSubsecao: null,
        idMarca: null,
        termoDigitado: null,
        gtin: null,
    },
    novoCadastro: false,
}

export const mutations = {
    SET_LISTAGEM_SELECTED(state, payload) {
        state.listagemSelected = payload
    },
    SET_LOADING_PRODUTOS_ATIVOS(state, payload) {
        state.loadingProdutosAtivos = payload
    },
    SET_PRODUTOS_ATIVOS(state, payload) {
        if (Array.isArray(payload)) {
            state.produtosAtivos = { content: payload }            
        } else {
            state.produtosAtivos = payload
        }

        if(state.produtosAtivos.content.length) {
            state.novoCadastro = false
        }        
    },
    SET_PRODUTO_DETAIL(state, payload) {
        state.produtoDetail = payload
    },
    SET_NEXT_PRODUTO_DETAIL(state, payload) {
        state.nextProdutoDetail = payload
    },
    SET_PRODUTO_ATUAL(state, payload) {
        state.produtoAtual = payload
    },
    SET_CURRENT_PAGE(state, payload) {
        state.currentPage = payload
    },
    SET_FILTRO_PENDENTE(state, payload) {
        state.filtroPendente = payload
    },
    SET_IMAGENS_RESPONSE(state, payload) {
        state.imagensResponse = payload
    },
    SET_NOVA_BUSCA(state, payload) {
        state.novaBusca = payload
    },
    SET_NOVO_CADASTRO(state, payload) {
        state.novoCadastro = payload
    },
}

export const getters = {
    getPerpage(state) {
        return state.produtosAtivos.size;
    },
    getRows(state) {
        if (state.produtosAtivos.totalPages && state.produtosAtivos.size) {
            return state.produtosAtivos.totalPages * state.produtosAtivos.size;
        } else {
            return null
        }
    },
    getImagemPrincipal(state) {
        return state.imagensResponse.find(i => i.principal)
    },
}

export const actions = {
    async listProdutosPendentes({ dispatch }, page) {
        const params = {
            page,
            size: 50,
        };

        dispatch('changeLoadingProdutosAtivos', true)
        try {
            return await axios
                .get("produto/pendentes", { params })
                .then((response) => {
                    response.data.content.forEach((produto) => {
                        if (!produto.idProdutoBagarote) {
                            produto["idProdutoBagarote"] = produto.idProduto;
                        }
                    });
                    dispatch('changeProdutosAtivos', response.data)
                })
        } catch (error) {
            return error
        } finally {
            dispatch('changeLoadingProdutosAtivos', false)
        }
    },

    async listPesquisaProdutos({ dispatch }, page) {
        const params = {
            page,
            size: 10,
            idSegmento: 1,
            idSecao: state.novaBusca.idSecao,
            idSubsecao: state.novaBusca.idSubsecao,
            idMarca: state.novaBusca.idMarca,
            termoDigitado: state.novaBusca.termoDigitado || null,
            gtin: state.novaBusca.gtin || null,
        };

        dispatch('changeLoadingProdutosAtivos', true)
        try {
            return await axios
                .get("sync/buscaProduto", { params })
                .then((response) => {
                    response.data.content.forEach((produto) => {
                        if (!produto.idProdutoBagarote) {
                            produto["idProdutoBagarote"] = produto.idProduto;
                        }
                    });
                    dispatch('changeProdutosAtivos', response.data)
                })
        } catch (error) {
            return error
        } finally {
            dispatch('changeLoadingProdutosAtivos', false)
        }

    },

    changeListagemSelected({ commit }, payload) {
        commit('SET_LISTAGEM_SELECTED', payload)
    },
    changeLoadingProdutosAtivos({ commit }, payload) {
        commit('SET_LOADING_PRODUTOS_ATIVOS', payload)
    },
    changeProdutosAtivos({ commit }, payload) {
        commit('SET_PRODUTOS_ATIVOS', payload)
    },
    changeProdutoDetail({ commit }, payload) {
        commit('SET_PRODUTO_DETAIL', payload)
    },
    changeNextProdutoDetail({ commit }, payload) {
        commit('SET_NEXT_PRODUTO_DETAIL', payload)
    },
    changeProdutoAtual({ commit }, payload) {
        commit('SET_PRODUTO_ATUAL', payload)
    },
    changeCurrentPage({ commit }, payload) {
        commit('SET_CURRENT_PAGE', payload)
    },
    changeFiltroPendente({ commit }, payload) {
        commit('SET_FILTRO_PENDENTE', payload)
    },
    changeImagensResponse({ commit }, payload) {
        commit('SET_IMAGENS_RESPONSE', payload)
    },
    changeNovaBusca({ commit }, payload) {
        commit('SET_NOVA_BUSCA', payload)
    },
    changeNovoCadastro({ commit }, payload) {
        commit('SET_NOVO_CADASTRO', payload)
    },
}